var Backbone = require('backbone');

/* keys in order of display -- top to bottom b/f pages appear */
var SECTION_XREF = {
    FC_FIELDS: {
        lbl: 'FC Fields',
        viewClass: 'fcFields'
    },
    SECURITY_PROPS: {
        lbl: 'Security',
        viewClass: 'rmaProps'
    },
    RMA_PROPS: {
        lbl: 'RMA',
        viewClass: 'rmaProps'
    },
    DOC_PROPS: {
        lbl: 'Doc Props',
        viewClass: 'docProps'
    },
    DOC_NOTES: {
        lbl: 'Doc Notes',
        viewClass: 'docNotes'
    }
};


var Pg = Backbone.Model.extend({
	defaults: {
        pgViewType: 'PAGE', //Others: FC_FIELDS, DOC_PROPS, DOC_NOTES; the basis for the child view type
        pgNum: null,
		pgText: null,
        pgId: null, //( only applicable for page types ... may want to subclass this in the future )
		top: null,
		bottom: null,
        pgLbl: null,
        viewCssClass: ''
	},
    initialize: function() {
        var type = this.get('pgViewType');
        if (type !== 'PAGE') {
            var sectionKeys = _.keys(SECTION_XREF).reverse();
            this.set({
                pgNum: sectionKeys.indexOf(type) * - 1 ,
                pgLbl: SECTION_XREF[type].lbl,
                viewCssClass: SECTION_XREF[type].viewClass
            });
        } else {
            this.set({
                pgLbl: 'Page ' + this.get('pgNum')
            });
        }
    }
});


var Pgs = Backbone.Collection.extend({
	model: Pg,
    comparator: 'pgNum', //sort by page num
	getByScrollPosition: function(curScrTop) {
		return this.filter(function(p) {
			return curScrTop >= p.get('top') && curScrTop <=  p.get('bottom');
		})[0];

	},
    hasPageNumber: function(pgNum) {
        return _.contains( this.pluck('pgNum'), pgNum );
    }
});


module.exports = Pgs;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/content/pages/pgUICollection.js
 ** module id = 550
 ** module chunks = 0
 **/